import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@uhg-abyss/web/ui/Tooltip';
import { Link } from '@uhg-abyss/web/ui/Link';
import { event as adobeTaggingEvent } from '@uhg-abyss/web/tools/event';
import { config } from '@uhg-abyss/web/tools/config';
import { Button } from '@uhg-abyss/web/ui/Button';

export const FormTooltip = ({ label, children }) => {
  const adobeTagging = () => {
    adobeTaggingEvent('EXIT_LINK_NAVIGATE');
  };

  let content = (
    <div>
      <b>{label}</b>
      <br />
      Proof of address may include utility bills, lease agreement or equivalent
      documentation to prove utilization of address.
    </div>
  );
  let ttId = `${label}-Tooltip`;

  if (label === 'CMS 116') {
    ttId = 'cliaUploadTooltip';
    content = (
      <div>
        The CLIA application (
        <Link
          id="practice-clia-tooltip-link"
          href={config('CLIA_CMS_FORM_URL')}
        >
          Form CMS-116
        </Link>
        ) collects information about your laboratory’s operation which is
        necessary to determine the fees to be assessed, to establish baseline
        data and to fulfill the statutory requirements for CLIA.
      </div>
    );
  }

  if (label === 'W-9 Form') {
    ttId = 'w9UploadTooltip';
    content = (
      <div>
        <Link
          href="https://www.irs.gov/pub/irs-pdf/fw9.pdf"
          onClick={adobeTagging}
        >
          Form W-9
        </Link>
        &nbsp; is an IRS information form that individuals and businesses use to
        send their taxpayer identification number to other individuals, clients,
        banks and other financial institutions. All W-9 forms must be signed and
        dated and not more than one year old.
      </div>
    );
  }

  return (
    <Tooltip id={ttId} content={content} variant="white">
      <Button aria-label="Tooltip information" rounded variant="ghost">
        {children}
      </Button>
    </Tooltip>
  );
};

FormTooltip.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
};

FormTooltip.defaultProps = {
  label: 'Upload Address Proof',
  children: null,
};
